export interface MenuBarPermission {
    menu_name: string;
    menu_key_name: string;
    is_log: boolean;
    view: boolean;
    have_feature: boolean;
}

export const mapMenuBarPermission = (data: any): MenuBarPermission => {
    if (!data) {
        throw new Error('Invalied Permission Interface type')
    }
    const SowSubSections: MenuBarPermission = {
        menu_name: data.menu_name,
        menu_key_name: data.menu_key_name,
        is_log: data.is_log,
        view: data.view,
        have_feature: data.have_feature,
    }

    return SowSubSections;
}

export const mapMenuBarPermissions = (data: any[]): MenuBarPermission[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Permission Interface data');
    }
    return data.map(mapMenuBarPermission);
};